import { motion } from "framer-motion";
import type { ReactNode } from "react";

export default function Section({
  id,
  children,
  className = "",
  delay = 0,
  compact = false,
}: {
  id?: string;
  children: ReactNode;
  className?: string;
  delay?: number;
  /* Tighter vertical rhythm, for sections that sit in a continuous run. */
  compact?: boolean;
}) {
  /* One padding class either way, so nothing collides in the cascade. */
  const pad = compact ? "py-10 md:py-16" : "py-20 md:py-32";

  return (
    <section id={id} className={`${pad} relative overflow-hidden ${className}`}>
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8, delay, ease: "easeOut" }}
        className="container mx-auto px-4 relative z-10"
      >
        {children}
      </motion.div>
    </section>
  );
}
